import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthTokenlessBaseService } from './auth-tokenless-base.service';
import { LoginResponse } from '../helper/dto/login-response.dto';
import { PublicSettingDto } from '../helper/dto/public-settings.dto';
import { AuthSessionResponse } from '../helper/dto/auth-session.dto';

@Injectable({ providedIn: 'root' })
export class AuthApiService extends AuthTokenlessBaseService {
    private credentialOptions = { withCredentials: true } as const;

    login(username: string, password: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(
            this.apiUrl('v1/auth/login'),
            {
                username: username,
                password: password
            },
            this.credentialOptions
        );
    }

    me(): Observable<AuthSessionResponse> {
        return this.http.get<AuthSessionResponse>(this.apiUrl('v1/auth/me'), this.credentialOptions);
    }

    renewToken(): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(this.apiUrl('v1/auth/renew'), {}, this.credentialOptions);
    }

    createActorToken(userId: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(this.apiUrl('v1/auth/actor-token'), { userId }, this.credentialOptions);
    }

    revokeActorToken(): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(this.apiUrl('v1/auth/actor-token/revoke'), {}, this.credentialOptions);
    }

    twoFactorLogin(name: string, code: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(this.apiUrl('v1/auth/two-factor'), { name, code }, this.credentialOptions);
    }

    verify(token: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(this.apiUrl('v1/auth/verify'), {
            token
        });
    }

    lock(token: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(this.apiUrl('v1/auth/lock'), {
            token
        });
    }

    resetRequest(mail: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(this.apiUrl('v1/auth/reset-request'), {
            mail
        });
    }

    reset(token: string, password: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(this.apiUrl('v1/auth/reset'), {
            token,
            password
        });
    }

    getThemeData(): Observable<PublicSettingDto[]> {
        return this.http.get<PublicSettingDto[]>(this.apiUrl('v1/setting/public/theme'));
    }

    getOIDCData(): Observable<PublicSettingDto[]> {
        return this.http.get<PublicSettingDto[]>(this.apiUrl('v1/setting/public/oidc'));
    }

    logout(): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(this.apiUrl('v1/auth/logout'), {}, this.credentialOptions);
    }
}
